module.exports = __webpack_public_path__ + "img/202402-xl.71569e60.png";